// src/components/audition-booking-wizard/WizardStepper.jsx
import React from 'react';
import { FaCheck } from 'react-icons/fa';
import { WIZARD_STEPS } from './utils/bookingHelpers'; // Use dynamic steps

const WizardStepper = ({ currentStep, selectedMode, handleStepClick }) => {
    const steps = WIZARD_STEPS(selectedMode);
    return (
        <div className="wizard-stepper-container">
            <div className="step-indicator-wrapper">
                <div className="step-progress-track"></div>
                {steps.map((label, i) => (
                    <div 
                        key={i} 
                        className={`step-item ${currentStep >= i + 1 ? 'active' : ''}`}
                        onClick={() => handleStepClick && handleStepClick(i)}
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="step-circle">{i + 1}</div>
                        <div className="step-label">{label}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default WizardStepper;